import { useState } from "react";
import { useLocale } from "../hooks/useLocale";
import styles from "./CancelButton.module.css";

interface Props {
  onCancel: () => Promise<void> | void;
}

export function CancelButton({ onCancel }: Props) {
  const { t } = useLocale();
  const [busy, setBusy] = useState(false);

  async function click() {
    if (busy) return;
    setBusy(true);
    try {
      await onCancel();
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      className={styles.btn}
      disabled={busy}
      onClick={() => void click()}
    >
      {t("chat.cancel_stream")}
    </button>
  );
}
